
import Vue from "vue";

export default Vue.extend({
  data: () => ({
    items: require("@/data/fanduel/bespokefanduel.json"),
  }),
});
